/* @flow */
import React, { type Node } from 'react';
import type { TVideo } from '../../types/helpful';
import { ArticleTitle, PlayIcon, VideoPoster, VideoPreview, VideoWrapper } from './styles';
import { playIcon } from '../../components/Icons';

type TProps = {
	item: TVideo,
};

const Video = ({ item }: TProps): Node => (
	<VideoWrapper to={`https://youtu.be/${item.youtubeCode}`} target="_blank" draggable="false">
		<VideoPreview>
			<VideoPoster style={{ backgroundImage: `url(https://img.youtube.com/vi/${item.youtubeCode}/0.jpg)` }} />
			<PlayIcon>{playIcon}</PlayIcon>
		</VideoPreview>
		<ArticleTitle>{item.title}</ArticleTitle>
	</VideoWrapper>
);

export default Video;
